module.exports = __webpack_public_path__ + "static/img/2_0_1@2x.e7b74a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/2_0_1@2x.png
// module id = C7nK
// module chunks = 8